import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ETwoFaStepConfirmCodeState, ETwoFaStepState, EUserRoles, IUser } from '../types/auth-session.types';

interface AuthSessionInitialState {
  isLoading: boolean;
  currentUser: IUser | null;
  twoFaStepState: ETwoFaStepState | null;
  twoFaStepConfirmCodeState: ETwoFaStepConfirmCodeState | null;
  currentOtpInput: string;
  userIdDocumentModalOpen: boolean;
  otpConfirmCallback: ((code: string) => void) | null;
}

const authSessionInitialState: AuthSessionInitialState = {
  currentUser: null,
  isLoading: false,
  twoFaStepConfirmCodeState: null,
  twoFaStepState: null,
  currentOtpInput: '',
  otpConfirmCallback: null,
  userIdDocumentModalOpen: false,
};

export const authSession = createSlice({
  name: 'authSession',
  initialState: authSessionInitialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    setCurrentOtpInput(state, action: PayloadAction<string>) {
      state.currentOtpInput = action.payload;
    },

    setTwoFaStepState(state, action: PayloadAction<ETwoFaStepState | null>) {
      state.twoFaStepState = action.payload;
    },

    setTwoFaStepConfirmCodeState(state, action: PayloadAction<ETwoFaStepConfirmCodeState | null>) {
      state.twoFaStepConfirmCodeState = action.payload;
    },

    setOtpConfirmCallback(state, action: PayloadAction<((code: string) => void) | null>) {
      state.otpConfirmCallback = action.payload;
    },

    setCurrentUser(state, action: PayloadAction<IUser | null>) {
      if (!action.payload) {
        state.currentUser = null;
        return;
      }

      let user = { ...action.payload };
      if (user.roles) {
        user.hasAdminAccess = user.roles.map((role) => role.name.toLowerCase()).includes(EUserRoles.ADMIN);
        user.hasCompanyAdminAccess = user.roles
          .map((role) => role.name.toLowerCase())
          .includes(EUserRoles.COMPANY_ADMIN);
      } else {
        user.roles = [];
      }
      user.fullName = user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : user.login;
      state.currentUser = user;
    },

    setUserIdDocumentModalOpen(state, action: PayloadAction<boolean>) {
      state.userIdDocumentModalOpen = action.payload;
    },
  },
});

export const {
  setCurrentUser,
  setIsLoading,
  setTwoFaStepState,
  setTwoFaStepConfirmCodeState,
  setCurrentOtpInput,
  setOtpConfirmCallback,
  setUserIdDocumentModalOpen,
} = authSession.actions;
